export const UPLOAD_SUCCESS = "UPLOAD_SUCCESS";
export const UPLOAD_FAILED = "UPLOAD_FAILED";
export const SCAN_FAILED = "SCAN_FAILED";
export type FileUploadStatus = typeof UPLOAD_SUCCESS | typeof UPLOAD_FAILED | typeof SCAN_FAILED;

export type FileScanResponse = {
  fileSafe: boolean;
  scanComplete: boolean;
};
